import React from 'react';
import WaterMeterInstallationPage from '../../water-meter-installation-page';

import wiringDiagram from '../../../../assets/product-interaction/joys500/joys500_wiring.jpg';

const LXSGYInstallation = () => (
  <WaterMeterInstallationPage
    model="LXSGY"
    backUrl="/product/lxsgy"
    wiringDiagram={wiringDiagram}
    wiringAlt="LXSGY 光电直读水表通过 M-BUS 接入 GW214 采集器接线图"
  />
);

export default LXSGYInstallation;
